<app-search-bar  *transloco="let t" (onSearch)="onSearchQueryInput($event)" (onSelectItem)="openEventDetails($event)"
                 [searchPlaceholder]="t('search.placeholder.races')" [isLoading]="isLoading" [inputValue]="inputValue" [showEmptyState]="showEmptyState" [items]="races"/>
